import axios from 'axios';
import { ENV_CONFIG } from '../../../config/config';

export const tiposDocumentosApi = (tokenAutorizacion:any) => axios.create({
    baseURL: `${ENV_CONFIG.TIPOS_DOCUMENTOS_URL}`,
    headers: {
        'Authorization': 'Bearer ' + tokenAutorizacion,
    }
});